import { createFileRoute } from '@tanstack/react-router';
import { WorkSetup } from '@/features/cleaner/work-setup';
import { HeaderDashboard } from '@/components/shared/header-dashboard';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/work-setup'
)({
  component: WorkSetupPage,
});

function WorkSetupPage() {
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>Work setup & Availability</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-6">
        <WorkSetup />
      </div>
    </div>
  );
}
